//Exclude Polaris Office SDK Function List

import { DOCUMENT_TYPE, PRODUCT_TYPE } from './global';

const removeRibbonTabMenus = {
  hwp: ['shape', 'picture', 'hwp_table'],
  sheet: ['picture', 'shape'],
  slide: [],
  word: ['shape', 'picture', 'table_design', 'table_layout']
}; //Ribbon Tab
const removeRibbonGroups = {
  hwp: ['hwp_page_insert', 'hwp_page_divide'],
  sheet: [],
  slide: [],
  word: []
}; //Ribbon Group
const removeRibbonMenus = {
  hwp: [
    'insert_library_picture_online',
    'insert_link_bookmark',
    'insert_symbol',
    'view_new_memo',
    'view_delete_memo',
    'view_previous_memo',
    'view_next_memo'
  ],
  sheet: ['memo_new', 'insert_library_picture_online'],
  slide: [
    'insert_library_video_online',
    'insert_library_picture_online',
    'review_comments_newcomment',
    'pen_inkmode_highlighter',
    'pen_inkmode_ruler'
  ],
  word: [
    'insert_library_picture_online',
    'memo_new',
    'insert_link_bookmark',
    'insert_symbol',
    'review_tracking_changes',
    'review_tracking_changes_apply',
    'review_tracking_changes_cancel',
    'review_tracking_changes_previous',
    'review_tracking_changes_next',
    'pen_inkmode_highlighter',
    'pen_inkmode_ruler',
    'layout_pagesetup_column',
    'layout_pagesetup_section_breaks',
    'layout_pagesetting_page',
    'layout_pagesetting_layout',
    'review_new_memo',
    'review_delete_memo',
    'review_previous_memo',
    'review_next_memo'
  ]
}; //Ribbon Menu
const removeContextMenus = {
  hwp: [
    'context_menu_border_and_background',
    'context_menu_table_property',
    'context_menu_hwp_block_formula',
    'context_menu_hwp_easy_formula',
    'context_menu_hwp_formula',
    'context_menu_hwp_insert_caption',
    'context_menu_hwp_formula_comma'
  ],
  sheet: ['context_menu_memo_new_comment'],
  slide: ['context_menu_slide_review_comments_newcomment'],
  word: []
}; //Context Menu
const removeDefaultFonts = ['arial', 'cour', 'tahoma', 'times', 'verdana'];

const getRemoveRibbonTabMenus = (productType, format) => {
  switch (productType) {
    case PRODUCT_TYPE.WITH_WHALE_SPACE:
      return [];
    default:
      break;
  }
  return removeRibbonTabMenus[format];
};

const getRemoveRibbonGroups = (productType, format) => {
  switch (productType) {
    case PRODUCT_TYPE.WITH_WHALE_SPACE:
      return [];
    default:
      break;
  }
  return removeRibbonGroups[format];
};

const getRemoveRibbonMenus = (productType, format) => {
  switch (productType) {
    case PRODUCT_TYPE.WITH_WHALE_SPACE:
      return [];
    default:
      break;
  }
  return removeRibbonMenus[format];
};

const getRemoveContextMenus = (productType, format) => {
  switch (productType) {
    case PRODUCT_TYPE.WITH_WHALE_SPACE:
      return [];
    default:
      break;
  }
  return removeContextMenus[format];
};

export {
  getRemoveRibbonTabMenus,
  getRemoveRibbonGroups,
  getRemoveRibbonMenus,
  getRemoveContextMenus,
  removeDefaultFonts
};
